import React from 'react';
import { Modal, Radio, Select } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
const RadioGroup = Radio.Group;
const Option = Select.Option;

class ClassFilter extends React.Component {

  state = { classList: null }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && this.props.classes && this.props.subjects) {
      let subjects = Object.entries(this.props.subjects);
      let classes = Object.entries(this.props.classes);
      let classList = []
      classes.map(clss => {
        let subject = subjects.filter(subj => subj[0] == clss[1].subject);
        subject = subject[0] && subject[0][1].name;
        let element = {
          id: clss[0],
          name: clss[1].name,
          grade: clss[1].grade,
          subject: subject,
          subjectId: clss[1].subject,
          students: clss[1].students && Object.keys(clss[1].students)
        }
        classList.push(element)
      })

      classList = classList.sort(function (a, b) {
        if (a.grades < b.grade) return -1;
        else if (a.grade > b.grade) return 1;
        return 0;
      });
      this.setState({ classList })
    }
  }

  changeClass = (id) => {
    let selected = this.state.classList.filter(clss => clss.id == id)
    this.props.changeClass(selected[0].id, selected[0].subject, selected[0].name, selected[0].grade, selected[0].subjectId, selected[0].students)
    console.log('qwert', selected[0].id, selected[0].subject, selected[0].name, selected[0].grade, selected[0].subjectId, selected[0].students);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Modal
          style={modal}
          bodyStyle={{ maxHeight: '70vh', overflow: 'scroll' }}
          title="Classes"
          visible={this.props.isOpen}
          onCancel={this.props.close}
          footer={false}
          width="350px"
        >
          <p style={{ color: '#ABB9C7', marginLeft: 10 }}>{t('Select class')}</p>
          <Select value={this.props.selectedClass.id} style={{ width: 300 }} onChange={(value) => this.changeClass(value)}>
            {this.state.classList && this.state.classList.map(clss => (
              <Option key={clss.id} value={clss.id}>{`${clss.grade} ${clss.subject} (${clss.name})`}</Option>
            ))}
          </Select>
        </Modal>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
)
export default enhancer(ClassFilter);


const modal = {
  position: 'absolute',
  right: '60px'
}



// WEBPACK FOOTER //
// ./src/components/ClassFilter/index.jsx